module.exports = __webpack_public_path__ + "static/media/img2.9fad6142.jpg";